module.exports = __webpack_public_path__ + "static/img/admin_headimg_garde&clazz.bc0829a1.png";